import React, { useState, useEffect } from 'react';
import Breadcrumb from '../components/common/Breadcrumb';
import api from '../services/api';
import LoadingSpinner from '../components/common/LoadingSpinner';

const BlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await api.get('/blogs/published');
        setBlogs(res);
      } catch (err) {
        console.error('Failed to fetch blogs:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  if (loading) return <LoadingSpinner fullScreen text="Loading blogs..." />;

  return (
    <div className="bg-white min-h-screen py-8">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl">
        <div className="border-b pb-4 mb-8">
          <Breadcrumb items={[{ label: 'Home', path: '/' }, { label: 'Blogs', path: '/blogs' }]} />
        </div>
        <h1 className="text-3xl font-light text-center text-gray-900 mb-10 tracking-wide">Our Blogs</h1>
        {blogs.length === 0 ? (
          <p className="text-center text-gray-500">No blogs published yet.</p>
        ) : (
          <div className="space-y-8">
            {blogs.map(blog => (
              <div key={blog._id} className="border-b border-gray-200 pb-6">
                {blog.image && (
                  <img src={blog.image} alt={blog.title} className="w-full h-64 object-cover rounded mb-4" />
                )}
                <h2 className="text-xl font-medium text-gray-800">{blog.title}</h2>
                <p className="text-sm text-gray-500 mb-2">{formatDate(blog.createdAt)}</p>
                <p className="text-gray-700">{blog.excerpt || blog.content.substring(0, 200)}...</p>
                <button className="mt-2 text-sm font-medium hover:underline" style={{ color: 'var(--primary-color)' }}>Read More</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogsPage;